// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { injectable } from 'inversify'
import type { HttpRequestContext } from '../Utils/HttpRequestContext'

import { consts } from './consts'
import { MobileAppPayloadNavigateToEnum, MobileAppPayloadTypeEnum } from './mobileViewServiceEnums'
import { MobileViewService } from './MobileViewService'

const mobileAppPayloadType = {
  session: 'SESSION',
  navigation: 'NAVIGATION',
  error: 'ERROR',
}

const mobileAppPayloadNavigateTo = {
  login: 'login',
  emailConfirmation: 'Email validation',
  close: 'close',
}
@injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class MobileViewHttpService implements MobileViewService {
  constructor(private httpRequestContext: HttpRequestContext) {}

  private userAgent: string =
    (this.httpRequestContext.headers && this.httpRequestContext.headers[consts.userAgentName]) || ''

  isMobileView = (): boolean => (this.userAgent.includes(consts.mobApp) ? true : false)

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getAllowedOtherFilters() {
    return consts.otherFilters
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getMobileAppPayload(
    mobileAppPayloadType: MobileAppPayloadTypeEnum,
    mobileAppPayloadNavigateToType: MobileAppPayloadNavigateToEnum
  ) {
    return {
      type: this.getPayloadType(mobileAppPayloadType),
      payload: { navigateTo: this.getNavigateTo(mobileAppPayloadNavigateToType) },
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getPayloadType(type: MobileAppPayloadTypeEnum) {
    const mobileAppPayloadTypes = {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      [MobileAppPayloadTypeEnum.session]: () => {
        return mobileAppPayloadType.session
      },
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      [MobileAppPayloadTypeEnum.navigation]: () => {
        return mobileAppPayloadType.navigation
      },
      // default
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      [MobileAppPayloadTypeEnum.error]: () => {
        return mobileAppPayloadType.error
      },
    }
    return (mobileAppPayloadTypes[type] || mobileAppPayloadTypes[MobileAppPayloadTypeEnum.error])()
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getNavigateTo(navigateOption: MobileAppPayloadNavigateToEnum) {
    const navigateTo = {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      [MobileAppPayloadNavigateToEnum.login]: () => {
        return mobileAppPayloadNavigateTo.login
      },
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      [MobileAppPayloadNavigateToEnum.emailConfirmation]: () => {
        return mobileAppPayloadNavigateTo.emailConfirmation
      },
      // default
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      [MobileAppPayloadNavigateToEnum.close]: () => {
        return mobileAppPayloadNavigateTo.close
      },
    }
    return (navigateTo[navigateOption] || navigateTo[MobileAppPayloadNavigateToEnum.close])()
  }
}

//  DON'T DELETE - used by DW
